var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDeleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9238,
    cy: 13.0537,
    r: 12.5,
    fill: "#F44336"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_6062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.145 18.8354C14.3474 18.8354 14.5207 18.6919 14.5207 18.5198L15.2142 10.5449C15.2431 10.344 15.0988 10.1719 14.8964 10.1433C14.694 10.1147 14.5207 10.2579 14.4919 10.4589L13.7983 18.4338C13.7981 18.6345 13.9427 18.8068 14.145 18.8354Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9199 18.8354C12.1511 18.8068 12.2956 18.6345 12.2666 18.4338L11.5732 10.4589C11.5444 10.2579 11.3708 10.1147 11.1687 10.1433C10.9663 10.1719 10.822 10.3442 10.8508 10.5449L11.5444 18.5198C11.5732 18.6919 11.7465 18.8354 11.9199 18.8354H11.9199Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8261 7.61934H15.0987V7.27516C15.0987 6.61541 14.5497 6.07031 13.8852 6.07031H12.1802C11.5157 6.07031 10.9666 6.61541 10.9666 7.27516V7.61934H7.26806C7.0657 7.61934 6.92139 7.79143 6.92139 7.96352V9.0823C6.92139 9.28321 7.09473 9.42648 7.26806 9.42648H7.81712L9.60855 19.7537C9.63738 19.9258 9.78189 20.0407 9.95523 20.0407H16.1676C16.341 20.0407 16.4855 19.926 16.5143 19.7537L18.3058 9.42648L18.8262 9.42668C19.0285 9.42668 19.1729 9.25459 19.1729 9.0825V7.96372C19.1729 7.79143 19.0285 7.61934 18.8262 7.61934H18.8261ZM11.7179 7.27516C11.7179 7.01702 11.9491 6.78751 12.2091 6.78751H13.9141C14.1741 6.78751 14.4053 7.01703 14.4053 7.27516V7.61934H11.7469V7.27516H11.7179ZM15.85 19.381H10.2444L8.53965 9.45535H17.5549L15.85 19.381ZM18.4795 8.73818H7.61501V8.33658H18.4506V8.73818H18.4795Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_6062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14.9459,
    fill: "white",
    transform: "translate(5.42334 5.58105)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleted);
export default __webpack_public_path__ + "static/media/ic-deleted.c9085c0bc2c8564c3b1322839e0d0ea8.svg";
export { ForwardRef as ReactComponent };